'use client';

import { createContext, useContext } from 'react';

export interface CustomFontFamilyOption {
  label: string;
  /** CSS font-family value written to the token when selected (the custom family name) */
  value: string;
}

interface CustomFontActionsContextValue {
  /** custom fonts of the theme being edited, surfaced in the font-family dropdown's CUSTOM section */
  customFontFamilies: CustomFontFamilyOption[];
  /** open the "add custom font" upload modal; absent when no consumer provides it (e.g. builder edit) */
  onAddCustomFont?: () => void;
  /** open the upload modal prefilled to edit an existing custom font by its array index */
  onEditCustomFont?: (index: number) => void;
  /** navigate to the fonts management surface */
  onManageFonts?: () => void;
}

// Default empty so FontFamilySelector degrades gracefully when no provider is mounted.
const CustomFontActionsContext = createContext<CustomFontActionsContextValue>({
  customFontFamilies: [],
});

export const CustomFontActionsProvider = CustomFontActionsContext.Provider;

export function useCustomFontActions() {
  return useContext(CustomFontActionsContext);
}
